// Icon set of the platform prototype: 24×24 outline paths drawn with the current colour (class "i" in theme.css).
const PATHS = {
  bolt: `<path d="M13 2 4 14h7l-1 8 9-12h-7z"/>`,
  drop: `<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/>`,
  flame: `<path d="M12 3c1 4 5 5 5 10a5 5 0 0 1-10 0c0-3 2-4 2-7 2 1 3 2 3 4 0-3-1-5 0-7z"/>`,
  thermo: `<path d="M10 14V5a2 2 0 0 1 4 0v9a4 4 0 1 1-4 0z"/>`,
  sun: `<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5 19 19M5 19l1.5-1.5M17.5 6.5 19 5"/>`,
  battery: `<rect x="3" y="7" width="16" height="10" rx="2"/><path d="M21 11v2M7 10v4M11 10v4"/>`,
  air: `<path d="M3 9h12a3 3 0 1 0-3-3M3 15h15a3 3 0 1 1-3 3"/>`,
  site: `<path d="M3 21V10l5 3V10l5 3V10l5 3V4h3v17z"/>`,
  building: `<path d="M4 21V5l8-3v19M12 21h8V9l-8-3M8 8h.01M8 12h.01M8 16h.01M16 12h.01M16 16h.01"/>`,
  line: `<path d="M3 17h18M6 17V9h4v8M14 17v-5h4v5"/>`,
  machine: `<rect x="5" y="7" width="14" height="10" rx="1"/><circle cx="12" cy="12" r="2.5"/><path d="M8 17v3M16 17v3"/>`,
  room: `<path d="M4 4h16v16H4zM4 12h7v8"/>`,
  zone: `<path d="M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5"/>`,
  floor: `<path d="M3 8l9-4 9 4-9 4zM3 13l9 4 9-4M3 17l9 4 9-4"/>`,
  home: `<path d="M3 11l9-7 9 7M5 10v10h14V10M10 20v-5h4v5"/>`,
  garage: `<path d="M3 10l9-6 9 6v10H3zM7 20v-6h10v6M7 17h10"/>`,
  cabin: `<path d="M3 20l9-15 9 15zM9 20v-5h6v5"/>`,
  chart: `<path d="M4 20V4M4 20h16M8 16l4-5 3 3 5-7"/>`,
  tree: `<path d="M4 5h7M4 5v14M8 12h7M8 19h7M4 12h4M4 19h4"/><circle cx="18" cy="5" r="2"/>`,
  list: `<path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01" stroke-width="2"/>`,
  map: `<path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3zM9 3v15M15 6v15"/>`,
  bell: `<path d="M6 16v-5a6 6 0 0 1 12 0v5l2 2H4zM10 21h4"/>`,
  coins: `<ellipse cx="9" cy="7" rx="6" ry="3"/><path d="M3 7v5c0 1.7 2.7 3 6 3s6-1.3 6-3V7M15 10.2c3.4.2 6 1.5 6 2.8v5c0 1.7-2.7 3-6 3s-6-1.3-6-3v-3"/>`,
  plug: `<path d="M9 3v5M15 3v5M6 8h12v3a6 6 0 0 1-12 0zM12 17v4"/>`,
  flow: `<path d="M3 7h5c5 0 5 10 10 10h3M3 17h5c2 0 3-2 4-4M15 7h6"/>`,
  auto: `<path d="M4 20 15 9M14 3v3M19 5l-2 2M21 10h-3M11 6l2 2"/>`,
  file: `<path d="M6 3h8l4 4v14H6zM14 3v4h4M9 13h6M9 17h6"/>`,
  users: `<circle cx="9" cy="8" r="3.5"/><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M16 4.5a3.5 3.5 0 0 1 0 7M18 14c2 .7 3 3 3 6"/>`,
  check: `<path d="M5 12l5 5 9-10"/>`,
  chev: `<path d="M9 6l6 6-6 6"/>`,
  chevl: `<path d="M15 6l-6 6 6 6"/>`,
  chevd: `<path d="M6 9l6 6 6-6"/>`,
  search: `<circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/>`,
  calendar: `<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>`,
  clock: `<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>`,
  x: `<path d="M6 6l12 12M18 6 6 18"/>`,
  swap: `<path d="M4 8h13l-3-3M20 16H7l3 3"/>`,
  pause: `<path d="M9 5v14M15 5v14"/>`,
  edit: `<path d="M4 20h4L19 9l-4-4L4 16z"/>`,
  gauge: `<path d="M4 16a8 8 0 1 1 16 0"/><path d="M12 16l4-5"/>`,
  target: `<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/>`,
  toggle: `<rect x="3" y="8" width="18" height="8" rx="4"/><circle cx="16" cy="12" r="2"/>`,
  folder: `<path d="M3 7h6l2 2h10v10H3z"/>`,
  inbox: `<path d="M3 13l3-8h12l3 8v6H3zM3 13h5l1 2h6l1-2h5"/>`,
  grip: `<path d="M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01" stroke-width="2.6"/>`,
  plus: `<path d="M12 5v14M5 12h14"/>`,
  alert: `<path d="M12 3 2 20h20zM12 10v4M12 17h.01"/>`,
  link: `<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>`,
  filter: `<path d="M4 5h16l-6 8v5l-4 2v-7z"/>`,
  expand: `<path d="M8 4h8M8 20h8M12 8V4M12 16v4M9 9l3-3 3 3M9 15l3 3 3-3"/>`,
  collapse: `<path d="M8 12h8M12 4v5M12 15v5M9 6l3 3 3-3M9 18l3-3 3 3"/>`,
  save: `<path d="M5 4h11l3 3v13H5zM8 4v5h7V4M8 20v-6h8v6"/>`,
  spark: `<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"/>`,
  leaf: `<path d="M5 19c0-8 5-14 15-14 0 10-6 15-14 15M5 19l7-7"/>`,
  up: `<path d="M12 19V5M6 11l6-6 6 6"/>`,
  down: `<path d="M12 5v14M6 13l6 6 6-6"/>`,
} as const;

export type IconName = keyof typeof PATHS;

export function Icon(props: { name: IconName; class?: string }) {
  // innerHTML only ever receives the constant paths above.
  return (
    <svg
      class={`i ${props.class ?? ""}`}
      viewBox="0 0 24 24"
      aria-hidden="true"
      innerHTML={PATHS[props.name]}
    />
  );
}
